import axios from 'axios'

const staticApi = axios.create({ baseURL: '/v1' })

export function useApiContext() {
  return { api: staticApi, anonymousApi: staticApi }
}
